import * as React from 'react';

/***** COMPONENTS *****/
import { Icon } from '../Icon';
import { Text } from '../Text';

/***** STYLES *****/
import * as styles from './Checkbox.css';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import { DEFAULT_CHECKBOX_TIMEOUT } from '../../constants/timeouts';
import { throttle } from '@cian/newbuilding-utils';

/***** TYPES *****/
export interface ICheckboxProps extends React.HTMLProps<HTMLInputElement> {
  As?: keyof JSX.IntrinsicElements;
  dataMark?: string;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
  onClick?(e: React.SyntheticEvent<HTMLInputElement>): void;
}

/***** COMPONENT *****/
export class Checkbox extends React.PureComponent<ICheckboxProps> {

  public handleChange = throttle(DEFAULT_CHECKBOX_TIMEOUT, (event: React.FormEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const { onClick } = this.props;
    if (onClick) {
      onClick(event);
    }
  });

  public render() {
    const {children, As = 'div', ...rest} = this.props;
    const {
      disabled,
      dataMark = 'Checkbox',
    } = rest;

    return (
      <label data-mark={dataMark} className={styles['checkbox']}>
        <As className={styles['handler']}>
          <input
            {...rest}
            type="checkbox"
            className={styles['hidden_input']}
            onClick={this.handleChange}
          />
          <span className={styles['box']}>
          <Icon
            type="check"
            size={10}
            color={disabled ? 'gray_0' : 'white'}
          />
        </span>
          <Text whiteSpace="nowrap">{React.Children.count(children) > 0 && NO_BREAK_SPACE}{children}</Text>
        </As>
      </label>
    );
  }
}
